import axios from 'axios';
import config from './config';
import { setLastLocation, isLoginUrl } from './auth-redirect';

const api = axios.create({
  baseURL: config.api.url
});

api.interceptors.request.use((requestConfig) => {
  let token = localStorage.getItem('token');
  if (token) {
    requestConfig.headers['Authorization'] = `Bearer ${token}`;
  }
  return requestConfig;
});

api.interceptors.response.use((response) => {
  return response;
}, (error) => {
  let response = error.response;
  let currentLocation = window.location.pathname + window.location.search;

  // For 401s coming from React axios calls, record the page that triggered auth failure once, then send user to login
  if (response.status === 401 && !isLoginUrl(currentLocation)) {
    setLastLocation(currentLocation);
    location.href = '/login';
  }

  return Promise.reject(error);
});

export default api;
